import {get} from 'lodash'
import { Maybe } from '@wix/wix-data-client-wix-code-adt'

const dataBindingFilterResolver =
  getDependencyById =>
    ({ filterId }) =>
      Maybe.fromNullable(getDependencyById(filterId)).chain(
        ({ masterDataset, fieldName }) => {
          let currentItem
          try {
            currentItem = masterDataset.api.getCurrentItem()
          } catch {}
          return Maybe.fromNullable(currentItem).map(item => {
            // lodash.get is used to support object binding.
            // for object field connections fieldName may be a path like 'objectField.childProp.valueProp'
            const value = get(item, fieldName)

            return value === undefined ? null : value
          })
        },
      )

export default dataBindingFilterResolver
